<template>
  <div>
    <epi-modal :opening-event-name="openingEventName" title="이용권">
      <template v-slot:offcanvas></template>
      <template v-slot:header-menu></template>
      <template v-slot:body>
        <label class="form-label">이용권 목록</label>

        <div class="accordion" id="voucherAccordion">
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button
                class="accordion-button"
                data-bs-toggle="collapse"
                data-bs-target="#voucher1"
              >
                4회기 이용권(개인)
              </button>
            </h2>
            <div
              class="accordion-collapse collapse show"
              id="voucher1"
              data-bs-parent="#voucherAccordion"
            >
              <div class="accordion-body vstack gap-3">
                <div>
                  <label class="form-label">이름</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="4회기 이용권(개인)"
                  />
                </div>

                <div>
                  <label class="form-label">회차</label>
                  <input type="number" class="form-control" placeholder="4" />
                </div>

                <div>
                  <label class="form-label">금액</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="400000"
                  />
                </div>

                <div class="d-flex justify-content-end gap-3">
                  <button class="btn btn-light">삭제</button>
                  <button class="btn btn-light">수정</button>
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header">
              <button
                class="accordion-button collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#voucher2"
              >
                8회기 이용권(그룹)
              </button>
            </h2>
            <div
              class="accordion-collapse collapse"
              id="voucher2"
              data-bs-parent="#voucherAccordion"
            >
              <div class="accordion-body vstack gap-3">
                <div>
                  <label class="form-label">이름</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="8회기 이용권(그룹)"
                  />
                </div>

                <div>
                  <label class="form-label">회차</label>
                  <input type="number" class="form-control" placeholder="8" />
                </div>

                <div>
                  <label class="form-label">금액</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="800000"
                  />
                </div>

                <div class="d-flex justify-content-end gap-3">
                  <button class="btn btn-light">삭제</button>
                  <button class="btn btn-light">수정</button>
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header">
              <button
                class="accordion-button collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#voucher3"
              >
                10회기 이용권
              </button>
            </h2>
            <div
              class="accordion-collapse collapse"
              id="voucher3"
              data-bs-parent="#voucherAccordion"
            >
              <div class="accordion-body vstack gap-3">
                <div>
                  <label class="form-label">이름</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="10회기 이용권"
                  />
                </div>

                <div>
                  <label class="form-label">회차</label>
                  <input type="number" class="form-control" placeholder="10" />
                </div>

                <div>
                  <label class="form-label">금액</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="1000000"
                  />
                </div>

                <div class="d-flex justify-content-end gap-3">
                  <button class="btn btn-light">삭제</button>
                  <button class="btn btn-light">수정</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="d-flex w-100 justify-content-end align-items-center">
          <div class="hstack gap-2">
            <button class="btn btn-light" data-bs-dismiss="modal">취소</button>
            <button class="btn btn-light">이용권 추가</button>
          </div>
        </div>
      </template>
    </epi-modal>
  </div>
</template>

<script>
import { EventName } from "@/const";

export default {
  name: "VoucherEditModal",
  data() {
    return {
      openingEventName: EventName.VoucherEditModalOpening,
    };
  },
};
</script>

<style lang="stylus" scope>
:root
  --bs-body-font-weight: normal;

</style>